import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
// import '../assets/css/icons.css';
import '../assets/css/style.css'
import '../assets/css/style_custom.css'
import loginbg from '../assets/images/login-bg.png';
// import logo from '../assets/images/logo.png'
import logo from '../assets/images/simulanis.png'
import honeywell from '../assets/images/honeywell.png'
import gail from '../assets/images/logo.png'
import { SERVER_IP, PORT } from '../Server';
import swal from 'sweetalert';
import axios from 'axios'; 
import $ from 'jquery';

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            email: "",
            password: '',
            focusPassword: false,
            showPassword: false,
            otpemail: "",
            viewMode: "Login",  // ForgetPassword , OTP , NewPassWord,
            ConfirmPassword: "",
            NewPassword: "",
            otp: "",
            isloading: false,
            errors: {
                NewPassword: '',
                ConfirmPassword: '',
            },
            time: {},
            seconds: 10,
            totalseconds: 10,
            latitude: '0',
            longitude: '0'

        }
        this.timer = 0;
    }
    secondsToTime = (secs) => {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }
    countDown = () => {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;
        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
        });

        // Check if we're at zero.
        if (seconds == 0) {
            if (this.state.viewMode === "OTP") {
                window.location.reload();
            }

            clearInterval(this.timer);
        }
    }
    onChangeInput = (e) => {
        e.preventDefault();
        this.checkRequirement(e.target.name, e.target.value);
        this.setState({ [e.target.name]: e.target.value })
    }
    componentDidMount() {
        var _this = this;
        navigator.geolocation.getCurrentPosition(function (position) {
            _this.setState({
                latitude: position.coords.latitude,
                longitude: position.coords.longitude
            })
        });
        /* -----  Bootstrap Tooltip ----- */
        $('[data-toggle="tooltip"]').tooltip();

        // document.cookie = "useracv=Johnqq; Secure;";
        document.getElementsByClassName('xp-rightbar')[0].style.marginLeft = "0px"
    }
    checkRequirement = (name, value) => {
        let errors = this.state.errors;

        switch (name) {

            case 'NewPassword':
                errors.NewPassword =
                    value.length < 4
                        ? 'Password must be 4 characters long!'
                        : '';
                break;
            case 'ConfirmPassword':
                errors.ConfirmPassword =
                    this.state.NewPassword !== value
                        ? 'Password and Confirm Password do not match !'
                        : '';
                break;
            default:
                break;
        }

        this.setState({ errors });
    }
    onSubmit = () => {
        // let axiosConfig = {
        //     headers: {
        //         'Content-Type': 'application/json;charset=UTF-8',
        //         "Access-Control-Allow-Origin": "*",
        //         "password": `${this.state.password}`,
        //     }
        // };
        var data = {
            email: this.state.email,
            password: this.state.password,
            logintype: "WebCredentails",
            devicetype: "WebBrowser",
            hardwaremodel: "chorme",
            hardwareos: "0",
            osversion: "0",
            applicationversion: "0",
            hardwareuniqueid: "khfksdkfhdskhfkdskhskjhfgkds",
            token: "sdkfhkdshgkshgkhfkg",
            longitude: this.state.longitude,
            latitude: this.state.latitude,
            ipaddress: "192.168.1.1"
        }
        var _this = this;
        axios.post(`${SERVER_IP}/login`, data, { withCredentials: true })
            .then(function (response) {

                if (response.status === 200) {
                
                    if (response.data.error === false) {
                        sessionStorage.clear();
                        sessionStorage.setItem("jwt", `${response.data.JWT_token}`);
                        sessionStorage.setItem("ud", `${JSON.stringify(response.data.userinfo)}`);
                        sessionStorage.setItem("webgl_token", response.data.userinfo.webgl_token);
                        window.location.href = "/dashboard"
                        return
                    }
                    _this.setState({ password: "" });
                    swal(response.data.status.message, "", "warning");
                } else {
                    _this.setState({ password: "" });
                    if (response.data.status.message) {
                        swal(response.data.status.message, "", "warning")
                        return
                    }
                    swal("Please check your Email and Password.", "", "warning")
                }

            })
            .catch(function (error) {
                _this.setState({ password: "" });
                swal("Please check your Email and Password.", "", "warning")
            });
    }
    forgetPassword = () => {
        this.setState({ viewMode: "ForgetPassword", isloading: false })
    }
    goToLogin = () => {
        this.setState({ viewMode: "Login", isloading: false })
    }
    SendEmail = () => {

        if (this.state.otpemail.length === 0) {
            return
        }
        var data = {
            email: this.state.otpemail
        }
        this.setState({ isloading: true });
        var _this = this;
        axios.post(`${SERVER_IP}/usersForgotPassword/forgotPassword`, data)
            .then(function (response) {

                if (response.status === 200) {
                    if (response.data.error === false) {
                        _this.setState({ viewMode: "OTP" })
                        _this.setState({ isloading: false });
                        // let timeLeftVar = _this.secondsToTime(_this.state.totalseconds);
                        //  this.setState({ time: timeLeftVar });
                        // if (_this.timer == 0 && _this.state.seconds > 0) {
                        //     _this.timer = setInterval(_this.countDown, 1000);
                        //   }
                        return
                    } else {
                        _this.setState({ isloading: false });
                        swal(response.data.message, "", "warning");
                    }
                } else {
                    _this.setState({ isloading: false });
                    swal("Please check your Email and Password.", "", "warning")
                }

            })
            .catch(function (error) {
                _this.setState({ isloading: false });
                swal("Please check your Email", "", "warning")
            });
    }
    reCheckEmail = () => {

        this.setState({ viewMode: "ForgetPassword", isloading: false })
    }
    CheckOTP = () => {

        if (this.state.otpemail.length === 0 || this.state.otp.length === 0) {
            return
        }
        var data = {
            email: this.state.otpemail,
            otp: this.state.otp
        }
        var _this = this;
        this.setState({ isloading: true })
        axios.post(`${SERVER_IP}/usersForgotPassword/verifyOTP`, data)
            .then(function (response) {

                if (response.status === 200) {
                    if (response.data.error === false) {
                        _this.setState({ isloading: false });
                        _this.setState({ viewMode: "NewPassWord" })
                        return
                    } else {
                        _this.setState({ isloading: false });
                        swal(response.data.message, "", "warning");
                    }
                } else {
                    _this.setState({ isloading: false });
                    swal("Please Try Again", "", "warning")
                }

            })
            .catch(function (error) {
                _this.setState({ isloading: false });
                swal("Please Try Again", "", "warning")
            });

    }
    SaveNewPassword = (e) => {
        e.preventDefault();
        Object.keys(this.state.errors).map((list, index) => this.checkRequirement(list, this.state[list]))
        this.checkRequirement(e)
        if (validateForm(this.state.errors)) {
        } else {
            swal("Invalid Input ..!!")
            return
        }
        if (this.state.otpemail.length === 0 || this.state.otp.length === 0) {
            return
        }
        var data = {
            email: this.state.otpemail,
            otp: this.state.otp,
            newPassword: this.state.NewPassword
        }
        this.setState({ isloading: true })
        var _this = this;
        axios.post(`${SERVER_IP}/usersForgotPassword/passwordReset`, data)
            .then(function (response) {

                if (response.status === 200) {
                    if (response.data.error === false) {
                        _this.setState({ isloading: false });
                        _this.setState({ viewMode: "Login" })
                        swal(response.data.message, "", "success");
                        return
                    } else {
                        _this.setState({ isloading: false });
                        swal(response.data.message, "", "warning");
                    }
                } else {
                    _this.setState({ isloading: false });
                    swal("Please Try Again", "", "warning")
                }

            })
            .catch(function (error) {
                _this.setState({ isloading: false });
                swal("Please Try Again", "", "warning")
            });

    }
    render() {
        const { errors } = this.state;

        return (
            <div>
                <div id="xp-container" className="login-container">
                    <div className="login"> 
                        <div className="xp-auth-box">
                            <div className="card">

                                {this.state.viewMode === "Login" ?
                                    <div className="card-body fadeInLeft">
                                        <div className="p-3">
                                            <div className="text-center mb-4">
                                                <img src={gail} alt="logo" style={{ width: "8rem" }} />
                                                <h4 className="mt-4" style={{ color: "#717171", fontWeight: "500" }}>Login to continue </h4>
                                            </div>
                                            <div className="form-group">
                                                <div className="input-group">
                                                    <span className="l-icon" title="Enter your Email">
                                                        <i className="mdi mdi-email-outline"></i>
                                                    </span>
                                                    <input className="in-form" type="text" name="email" value={this.state.email} onChange={this.onChangeInput} id="username" placeholder="Enter your Email" autofocus onKeyPress={event => {
                                                        if (event.key === 'Enter') {
                                                            this.refs.password.focus();
                                                        }
                                                    }} required />
                                                </div>

                                            </div>
                                            <div className="form-group">
                                                <div className="input-group">
                                                    <span className="l-icon" title="Enter your Password">
                                                        <i className="mdi mdi-lock"></i>
                                                    </span>
                                                    <span className="l-icon-eye" onClick={() => this.setState({ showPassword: !this.state.showPassword })} >
                                                        {this.state.showPassword ?
                                                            <i className="mdi  mdi-eye-off" title="Hide Password"></i>
                                                            :
                                                            <i className="mdi mdi-eye" title="Show Password"></i>
                                                        }
                                                    </span>
                                                    {this.state.showPassword ?
                                                        <input className="in-form" type="text" value={this.state.password} name="password" onChange={this.onChangeInput} id="password" placeholder="Password" onKeyPress={event => {
                                                            if (event.key === 'Enter') {
                                                                this.onSubmit();
                                                            }
                                                        }} ref="password" required />
                                                        : <input className="in-form" type="password" value={this.state.password} name="password" onChange={this.onChangeInput} id="password" placeholder="Password" onKeyPress={event => {
                                                            if (event.key === 'Enter') {
                                                                this.onSubmit();
                                                            }
                                                        }} ref="password" required />
                                                    }
                                                </div>
                                            </div>
                                            <div className="form-row">
                                                <div className="form-group col-6">
                                                    {/* <div className="custom-control custom-checkbox">
                                                        <input type="checkbox" className="custom-control-input" id="rememberme" />
                                                        <label className="custom-control-label" for="rememberme">Remember Me</label>
                                                    </div> */}
                                                </div>
                                                <div className="form-group col-6 text-right">
                                                    <label className="forgot-psw" title="Forgot Password?">
                                                        <a id="forgot-psw" onClick={this.forgetPassword} href="javascript:void(0);">Forgot Password?</a>
                                                    </label>
                                                </div>
                                            </div>
                                            <button onClick={this.onSubmit} className="btn btn-primary btn-rounded l-btn  btn-block">Login</button>
                                        </div>
                                    </div> 
                                    : null} 
                                {this.state.viewMode === "ForgetPassword" ?
                                    <div className="card-body fadeInRight"> 
                                        <div className="p-3">
                                            <div className="text-center mb-3">
                                                <img src={gail} alt="logo" style={{ width: "8rem" }} />
                                                <h4 className="text-uppercase mt-4" style={{ color: "#717171", fontWeight: "500" }}>Forgot Password</h4>
                                            </div>
                                            <div className="form-group">
                                                <div className="input-group">
                                                    <span className="l-icon" title="Enter your Email">
                                                        <i className="mdi mdi-email-outline"></i>
                                                    </span>
                                                    <input className="in-form" type="text" name="otpemail" value={this.state.otpemail} onChange={this.onChangeInput} id="username" placeholder="Enter your Email" autofocus required />
                                                </div>

                                            </div>

                                            <button onClick={this.SendEmail} disabled={this.state.isloading} className="btn btn-primary btn-rounded l-btn  btn-block">Request Password</button>
                                            <div className="form-row">
                                                <div className="form-group col-6">

                                                </div>
                                                <div className="form-group col-6 text-right mt-3">
                                                    <label className="forgot-psw" title="Go To Login?">
                                                        <a id="forgot-psw" onClick={this.goToLogin} href="javascript:void(0);"><i className="mdi mdi-login-variant"></i> Go To Login</a>
                                                    </label>
                                                </div>
                                            </div>
                                            {/* <button onClick={this.onSubmit} className="btn btn-primary btn-rounded l-btn  btn-block">Log In</button> */}
                                        </div>
                                    </div>

                                    : null}
                                {this.state.viewMode === "OTP" ?
                                    <div className="card-body fadeInLeft">
                                        <div className="p-3">
                                            <div className="text-center mb-3">
                                                <img src={gail} alt="logo" style={{ width: "8rem" }} />
                                                <h4 className="mt-4" style={{ color: "#717171", fontWeight: "500" }}>OTP is sent to <b>{this.state.otpemail}</b> <br /> Please Check The Email.
                                                {/* <br />
                                                 {this.state.time.m} : {this.state.time.s} */}
                                                </h4>
                                            </div>
                                            <div className="form-group">
                                                <div className="input-group">
                                                    <span className="l-icon" title="Enter your Email">
                                                        <i className="mdi mdi-numeric"></i>
                                                    </span>
                                                    <input className="in-form" type="number" name="otp" value={this.state.otp} onChange={this.onChangeInput} id="username" placeholder="Enter your OTP" autofocus required />
                                                </div>

                                            </div>
                                            <button onClick={this.CheckOTP} disabled={this.state.isloading} className="btn btn-primary btn-rounded l-btn  btn-block">Proceed</button>
                                            <div className="form-row mt-4">
                                                <div className="form-group col-6">
                                                    <a id="forgot-psw" onClick={this.reCheckEmail} href="javascript:void(0);"><i className="mdi mdi-email-outline mr-2"></i>Change the Email ID</a>
                                                </div>
                                                <div className="form-group col-6 text-right">
                                                    <label className="forgot-psw" title="Go To Login?">
                                                        <a id="forgot-psw" onClick={this.goToLogin} href="javascript:void(0);"><i className="mdi mdi-login-variant mr-2"></i>Go To Login</a>
                                                    </label>
                                                </div>
                                            </div>
                                            {/* <button onClick={this.onSubmit} className="btn btn-primary btn-rounded l-btn  btn-block">Log In</button> */}
                                        </div>
                                    </div>

                                    : null}
                                {this.state.viewMode === "NewPassWord" ?
                                    <div className="card-body fadeInRight">
                                        <div className="p-3">
                                            <div className="text-center mb-3">
                                                <img src={gail} alt="logo" style={{ width: "8rem" }} />
                                                <h4 className="mt-4" style={{ color: "#717171", fontWeight: "500" }}>Please Enter The New Password.</h4>
                                            </div>
                                            <div className="form-group">
                                                <div className="input-group">
                                                    <span className="l-icon" title="Enter New Password">
                                                        <i className="mdi mdi-lock"></i>
                                                    </span>
                                                    <input className="in-form" type="password" name="NewPassword" value={this.state.NewPassword} onChange={this.onChangeInput} id="username" placeholder="Enter New Password" autofocus required />
                                                    {errors.NewPassword.length > 0 && <span className='text-danger'>{errors.NewPassword}</span>}

                                                </div>

                                            </div>
                                            <div className="form-group">
                                                <div className="input-group">
                                                    <span className="l-icon" title="Confirm Password">
                                                        <i className="mdi mdi-lock"></i>
                                                    </span>
                                                    <input className="in-form" type="password" name="ConfirmPassword" value={this.state.ConfirmPassword} onChange={this.onChangeInput} id="username" placeholder="Confirm Password" autofocus required />
                                                    {errors.ConfirmPassword.length > 0 && <span className='text-danger'>{errors.ConfirmPassword}</span>}

                                                </div>

                                            </div>
                                            <button onClick={this.SaveNewPassword} disabled={this.state.isloading} className="btn btn-primary btn-rounded l-btn  btn-block">Save New Password</button>

                                            {/* <button onClick={this.onSubmit} className="btn btn-primary btn-rounded l-btn  btn-block">Log In</button> */}
                                        </div>
                                    </div>

                                    : null}


                                  
                            </div>
                        </div>
                        <div className="simulanislogo">
                            <div className="h-logo" style={{display:'flex', alignItems:'center', justifyContent:'flex-end'}}>
                                <span style={{whiteSpace:'nowrap'}}>Powered By  </span>  
                                <img src={logo} style={{width:'75px', marginLeft:'10px'}} alt="simulanis" />
                            </div>
                        </div>

                    </div>
                    <div className="login-bg">
                        <img src={loginbg} alt="login" />
                    </div>
                </div>
            </div>
        )
    }
}
export default Login

const validateForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach(
        (val) => val.length > 0 && (valid = false)
    );
    return valid;
}